<div class="h-100 d-flex align-items-center justify-content-center">
        <div >
            <img  [src]="icons.not_authorized"  class="img-fluid"/>
            <div class="text">
                <p class="unauthorized">{{ 'shared.unauthorized' | translate }}</p>
                <p class="unauthorized-text">{{ 'shared.dont_have_access' | translate }}</p>
            </div>
        </div>
</div>